import React, { useEffect, useRef } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Grid, Input, Line, SelectForm } from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import Draggable from 'react-draggable'
import { useForm } from 'react-hook-form'
import { SPACING } from 'utils'
import { TipoPendencia } from 'utils/types'
import * as yup from 'yup'

import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled,
  FormDialog
} from './ModalEditPendingItems.style'

interface IModalEditPendingItems {
  showModal: boolean
  toggleModal: () => void
  onSubmit: any
  pendingData: TipoPendencia
  register?: any
}

const schema = yup
  .object({
    txDescricao: yup
      .string()
      .required('Informe o nome da pendência')
      .max(500, 'Máximo 500 caracteres'),
    txTipo: yup.string().required('Informe o Tipo')
  })
  .required()

const ModalEditPendingItems: React.FC<IModalEditPendingItems> = ({
  onSubmit,
  showModal,
  toggleModal,
  pendingData
}) => {
  const { control, handleSubmit, reset, formState, setValue } = useForm<TipoPendencia>({
    resolver: yupResolver(schema)
  })

  useEffect(() => {
    setValue('txDescricao', pendingData?.txDescricao)
    setValue('idTipoPendencia', pendingData?.idTipoPendencia)
    setValue('txTipo', pendingData?.txTipo)
  }, [showModal])



  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      reference={draggableReference}
      showModal={showModal}
      onClose={toggleModal}
      width={'lg'}
    >
      <Line />
      <FormDialog
        onSubmit={(submitData) => {
          handleSubmit((data) => {
            onSubmit(Object.assign(pendingData, data))
          })(submitData).then(() => {
            resetModalState(draggableReference)
          })
        }}
      >
        <DialogTitleStyled>Editar Tipo Pendência</DialogTitleStyled>
        <DialogContentStyled>
          <Grid
            gridCols="2fr 4fr 2fr"
            gridGap={`${SPACING.spacing10}`}
            margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
          >
            <SelectForm
              control={control}
              errors={formState.errors}
              formValue="txTipo"
              label="Tipo Documento"
              defaultValue={pendingData?.txTipo}
              listOptions={[
                { label: 'Trabalhista', value: 'Trabalhista' },
                { label: 'Previdenciário', value: 'Previdenciario' },
                { label: 'Outros', value: 'Outros' }
              ]}
              placeholder="Selecione"
              marginRight={SPACING.spacing20}
            />
            <Input
              control={control}
              label="Pendência"
              formValue="txDescricao"
              errors={formState.errors}
              required
              defaultValue={pendingData?.txDescricao}
            />
          </Grid>
        </DialogContentStyled>

        <DialogActionsStyled>
          <Button
            text="Voltar"
            variantButton="outlined"
            marginBottom={SPACING.spacing20}
            marginRight={SPACING.spacing10}
            onClick={() => {
              toggleModal()
              resetModalState(draggableReference)
              reset()
            }}
          />
          <Button
            text="limpar"
            variantButton="text"
            onClick={() => {
              reset({
                txDescricao: ''
              })
            }}
            marginBottom={SPACING.spacing20}
            marginRight={SPACING.spacing10}
          />
          <Button
            text="Salvar"
            type="submit"
            marginBottom={SPACING.spacing20}
            marginRight={SPACING.spacing10}
          />
        </DialogActionsStyled>
      </FormDialog>
    </DraggableDialog>
  )
}

export default ModalEditPendingItems
